module.exports = __webpack_public_path__ + "static/img/blank_table.3779aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/components/blank_table.png
// module id = LuU/
// module chunks = 1